<template>
  <a-row class="content-fix org">
    <a-row class="content-title" type="flex">
      <a-button
        type="primary"
        class="back-btn"
        @click="$router.push({ name: 'statistics' })"
      >
        <i class="t-transition icons icon-chevron-left" />
        Назад
      </a-button>

      <a-row class="post-search" type="flex">
        <a-select
          v-model="perPage"
          class="table__parpage"
          option-filter-prop="children"
          placeholder="Все"
          @change="tableperPage"
        >
          <a-select-option
            v-for="(limit, index) in LimitList"
            :key="index"
            :value="limit.value"
          >
            {{ limit.title }}
          </a-select-option>
        </a-select>

        <a-button
          type="primary"
          class="all-news-btn"
          style="margin: 0 15px"
          @click="Allnews"
        >
          Все
        </a-button>

        <a-button type="primary" @click="$router.push({ name: 'kpi-create' })">
          <a-icon type="plus" />{{ $t("Add") }}
        </a-button>
      </a-row>
    </a-row>
    <a-table
      :key="$route.fullPath"
      :columns="columns"
      :loading="loading"
      :data-source="tableProps.results"
      :pagination="false"
      :scroll="{ y: 600 }"
      :row-key="(record) => record.id"
    >
      <template slot="file" slot-scope="record">
        {{ getFileDisplay(record) }}
      </template>
      <template slot="operation" slot-scope="item">
        <div class="action">
          <a-button
            class="edit-btn"
            type="primary"
            @click="downloadFile(item.file)"
          >
            <a-icon class="action-btns" type="download" />
          </a-button>

          <a-button type="danger" @click="removeItem(item.id)">
            <a-icon class="action-btns" type="delete" />
          </a-button>
        </div>
      </template>
    </a-table>

    <a-row class="mt-1" style="padding-bottom: 15px">
      <a-pagination
        :current="page"
        :default-page-size="perPage"
        :total="+tableProps.count || 0"
        @change="toPage"
      />
    </a-row>
  </a-row>
</template>

<script>
import moment from "moment"

export default {
  data() {
    return {
      loading: false,
      selectedRowKeys: [],
      columns: [
        {
          title: "T/r",
          key: "id",
          dataIndex: "id",
          align: "center",
          width: "80px",
          scopedSlots: { customRender: "id" }
        },
        {
          title: "Fayl",
          key: "file",
          // dataIndex: "file",
          align: "left",
          scopedSlots: { customRender: "file" }
        },
        {
          title: this.$t("TableAction"),
          key: "operation",

          fixed: "right",
          scopedSlots: { customRender: "operation" }
        }
      ],
      search: "",
      tableProps: {
        results: [],
        count: 1
      },
      title: {
        uz: "Ichki audit xizmati rahbari va xodimlar faoliyati samaradorligining reytinggi",
        oz: "Ички аудит хизмати раҳбари ва ходимлар фаолияти самарадорлигининг рейтингги",
        ru: "Рейтинг эффективности деятельности руководителя и сотрудников службы внутреннего аудита",
        en: "Performance rating of the head and staff of the internal audit service"
      },
      LimitList: [
        {
          value: 10,
          title: "10"
        },
        {
          value: 20,
          title: "20"
        },
        {
          value: 40,
          title: "40"
        }
      ],
      perPage: 20,
      page: 1,
      cardsIsEmpty: true,
      offset: 0
    }
  },
  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },
  methods: {
    tableperPage() {
      this.offset = 0
      this.fetchData()
    },
    getFileDisplay(record) {
      const fileUrl = record.file
      if (!fileUrl) return this.$t("NoFileAvailable") || "No file available"

      // Get the localized title

      const locale = this.$i18n.locale || "ru"
      const title = this.title[locale] || this.title.ru

      // Extract the date from the URL
      const dateMatch = fileUrl.match(/\/(\d{4}-\d{2}-\d{2})\//)
      let formattedDate = this.$t("UnknownDate") || "Unknown date"
      if (dateMatch && dateMatch[1]) {
        formattedDate = moment(dateMatch[1]).format("DD.MM.YYYY")
      }

      // Optionally use other fields from record
      return `${title} (${formattedDate})`
    },
    downloadFile(fileUrl) {
      if (!fileUrl) {
        this.$message.error("File URL is not available.")
        return
      }

      try {
        // Decode the file name from the URL for a user-friendly name
        const fileName =
          decodeURIComponent(fileUrl.split("/").pop()) || "downloaded-file.xlsx"

        // Create a temporary link element
        const link = document.createElement("a")
        link.href = fileUrl
        link.download = fileName // Set the decoded file name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link) // Clean up

        this.$message.success("File download started.")
      } catch (error) {
        console.error("Error downloading file:", error)
        this.$message.error("Failed to download the file.")
      }
    },
    async Allnews() {
      this.loading = true
      this.perPage = null
      this.categoryProps = {
        results: [],
        count: 0
      }
      try {
        const r = await this.$store.dispatch("kpi/fetch", {
          type: 0
        })
        if (r) {
          this.$set(this, "tableProps", {
            results: r || []
          })
        }
      } catch (e) {
        this.$sentry.captureMessage(e)
      }
      this.loading = false
    },
    toPage(arg) {
      this.$router.push({ query: { page: arg } })
    },
    SearchInput() {
      this.offset = 0
      this.fetchData()
    },
    async fetchData() {
      this.loading = true
      this.offset = +this.$route.query.page || 1
      this.page = this.offset
      this.offset = (this.offset - 1) * this.perPage
      try {
        const data = await this.$store.dispatch("kpi/fetch", {
          limit: this.perPage,
          offset: this.offset,
          search: this.search,
          type: 0
          // is_active: false
        })
        if (data) {
          this.$set(this, "tableProps", {
            results: data.results || [],
            count: data.count
          })
        }
      } catch (error) {
        console.error(error)
        this.loading = false
      }

      this.loading = false
    },

    async removeItem(id) {
      try {
        // Dispatch the Vuex action to delete the item
        const res = await this.$store.dispatch("kpi/removeItemAction", id)

        // Check the API response and display appropriate feedback
        if (res && res.status === 204) {
          this.$message.success("Успешно удалено") // Success message
          await this.fetchData() // Refresh the table to reflect changes
        } else {
          this.$message.error("Не удалось удалить элемент. Повторите попытку.") // Error message
        }
      } catch (error) {
        // Log and display an error notification
        console.error(`Error deleting item with ID ${id}:`, error)
        this.$message.error("Произошла ошибка при удалении элемента.")
      }
    }
  }
}
</script>

<style>
.wanted-search-input-wrapper {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 430px;
  flex: 0 0 430px;
  justify-content: space-around;
}

.custom-table .ant-table-thead > tr > th {
  text-align: center;
  background-color: #f5f5f5;
  font-weight: bold;
}
.custom-table .ant-table-cell {
  text-align: center;
}
.action {
  display: flex;
}
</style>
